import invoice from "./+invoice";
import home from "./+home";
import auth from "./+auth";
import dash from "./+dash";

const Routes = [...invoice,...home,...auth,...dash];

export default Routes;
